import { Skeleton } from '@ui/Skeleton';
import { FeedAsideSkeleton } from '@components/FeedAside';
import { ProductsFeedSleketon } from '@components/ProductsFeedSleketon';

import s from './ProfileProductsFeed.sss';

export const ProfileProductsFeedSkeleton = () => (
  <div className={s.root}>
    <FeedAsideSkeleton />
    <main className={s.main}>
      <div className={s.controls}>
        <div className={s.sort}>
          <Skeleton
            width="150px"
            height="40px"
            align="left"
          />
        </div>
        <div className={s.filtersButton}>
          <Skeleton
            width="150px"
            height="40px"
            align="right"
          />
        </div>
      </div>

      <ProductsFeedSleketon count={8} />
    </main>
  </div>
);
